import React from "react";
import { Box, Typography } from "@mui/material";
import { Instagram } from "@mui/icons-material";

interface InstagramBannerProps {
  handle: string;
  url: string;
}

export default function InstagramBanner({ handle, url }: InstagramBannerProps) {
  return (
    <Box 
      sx={{ 
        height: {
          xs: 120,
          sm: 140,
          md: 160,
        },
        backgroundColor: '#010101cc',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
        padding: {
          xs: '0 16px',
          sm: '0 24px',
          md: '0',
        },
        '&:hover': {
          backgroundColor: '#010101e6',
        }
      }}
      onClick={() => window.open(url, '_blank')}
    >
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center',
          gap: {
            xs: 0.5,
            sm: 0.75,
            md: 1,
          }
        }}
      >
        <Instagram
          sx={{ 
            fontSize: {
              xs: 36,
              sm: 44,
              md: 56,
            },
            color: 'white',
            transition: 'transform 0.3s',
            '&:hover': {
              transform: 'scale(1.1)',
            }
          }} 
        />
        
        <Box sx={{ textAlign: 'left' }}>
          <Typography 
            variant="h3" 
            sx={{ 
              fontFamily: '"Rubik", sans-serif',
              fontWeight: 'bold',
              color: 'white',
              lineHeight: 1.2,
              fontSize: {
                xs: '1.5rem',
                sm: '2rem',
                md: '2.5rem',
                lg: '3rem',
              }
            }}
          >
            {handle}
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              fontFamily: '"Rubik", sans-serif',
              color: 'white',
              fontWeight: 400,
              lineHeight: 1.2,
              ml: {
                xs: 0.5,
                sm: 0.75,
                md: 1,
              },
              fontSize: {
                xs: '0.65rem',
                sm: '0.75rem',
                md: '0.875rem',
              },
              letterSpacing: {
                xs: '1px',
                sm: '1.5px',
                md: '2px',
              }
            }}
          >
            SEGUINOS EN INSTAGRAM
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}














